import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Tags } from 'apps/tag';

import { TagsListWrapper } from 'apps/project/views/tagsList.styles';

const TagsList = observer(props => {
  const { app } = props;
  return (
    <TagsListWrapper>
      <Tags type='Skills' tags={app.tags} app={app} mobileCentered />
    </TagsListWrapper>
  );
});

TagsList.propTypes = {
  app: PropTypes.object,
};

export default TagsList;
